import { withInstall } from '../../utils/install';
import BreadcrumbItem from './index.vue';

export const IvueBreadcrumbItem = withInstall(BreadcrumbItem);
export default IvueBreadcrumbItem;

export * from './index.vue';
